import { useEffect, useReducer, useRef, useState } from 'react';
import Wave from '@foobar404/wave';
import './App.css';
import NextBtn from './components/NextBtn';
import PlayAndPauseBtn from './components/PlayAndPauseBtn';
import PrevBtn from './components/PrevBtn';
import { initialState, stateReducer } from './state';
import useController from './controller';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

function App() {
  const songRef = useRef(null);
  const [wave] = useState(new Wave());
  const [state, dispatch] = useReducer(stateReducer, initialState);
  const currentSong = state.audios[state.currentSongIndex];

  const {
    setIsPaused,
    setSongTimeline,
    updateStatusBar,
    setSongCurrentIndex,
  } = useController(dispatch);

  useEffect(() => {
    wave.fromElement('audio_element', 'canvas_element', {
      type: 'flower',
      stroke: 2,
      colors: ['#000', '#fff'],
    });
  }, [wave]);

  useEffect(() => {
    window.document
      .getElementById('audio_element')
      .addEventListener('loadedmetadata', (e) => {
        songRef.current = e.target;
      });
  }, []);
  return (
    <div className="root">
      <div className="container">
        <div>
          <div className="imgContainer">
            <LazyLoadImage
              effect="blur"
              placeholderSrc={currentSong.placeholder}
              src={currentSong.img}
              alt=""
              width="350px"
              height="350px"
              className={`img animation-fade ${
                state.isPaused ? '' : 'animation-spin'
              }`}
            />
            <canvas
              className="canvas"
              width="350px"
              height="350px"
              id="canvas_element"
            />
          </div>
          <div className="song-info-container">
            <p className="title animation-fade">{currentSong.songName}</p>

            <p className="artise animation-fade">{currentSong.artist}</p>
            <audio
              autoPlay={
                state.currentSongIndex !== 0 || state.currentSongIndexChanged
              }
              src={currentSong.src}
              id="audio_element"
              onTimeUpdate={() => updateStatusBar(songRef)}
              onEnded={() => setSongCurrentIndex(1)}
            />
          </div>

          <div>
            <input
              type="range"
              min="0"
              value={state.barValue}
              onChange={(e) => setSongTimeline(e, songRef)}
              max={songRef.current?.duration || 100}
              className="input-range"
            />
          </div>

          <div className="controller-container">
            <PrevBtn setSongCurrentIndex={setSongCurrentIndex} />
            <PlayAndPauseBtn
              isPaused={state.isPaused}
              songRef={songRef}
              setIsPaused={setIsPaused}
            />
            <NextBtn setSongCurrentIndex={setSongCurrentIndex} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
